import React from 'react'
import {getUserSettings} from '../../storage'
import DefaultDebit from './adddebitnote'
import BatchDebit from './batchdebit'
export default class InvoiceMode extends React.Component {
  render()  {
    let settings = getUserSettings()
    if(typeof settings !== "undefined" && settings !== null && settings.item_track_batches) {
        return <BatchDebit {...this.props} />
    }
    else {
        return <DefaultDebit {...this.props} />
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/debit/debitselect.js